import Vue from 'vue'
import Router from 'vue-router'
import MapLayout from './views/MapLayout.vue'
import Search from '@/views/Search.vue'
import PackageTracker from '@/views/PackageTracker.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      component: MapLayout,
      children: [
        {
          path: '/:country/:language/package/tracking/:trackingNumber/',
          name: 'package-tracker',
          component: PackageTracker,
          props: true
        },
        {
          path: '/:country/package/tracking/:trackingNumber/',
          redirect: '/:country/en/package/tracking/:trackingNumber/',
          props: true
        },
        {
          path: '/package/tracking/:trackingNumber/',
          redirect: '/ng/en/package/tracking/:trackingNumber/',
          props: true
        },

        // work around to delete the leading garbage on the url
        {
          path: '/',
          redirect: { name: 'search', props: { clutter: '' } }
        },
        {
          path: '/:clutter?',
          name: 'search',
          component: Search,
          props: true
        }
      ]
    }
  ]
})
